import type { DatabaseTables, TableName } from "../types";

export function makeReactionTableName(
	table: TableName<DatabaseTables>,
	columnName: string
): TableName<DatabaseTables> {
	return `${table}__${columnName}`;
}
